import React, { useEffect, useState } from "react";
import { supabase } from "../../supabase/client";
import { s3Client } from "../../s3aws/s3Client";
import { PutObjectCommand } from "@aws-sdk/client-s3";
import { v4 as uuidv4 } from "uuid";
import { Buffer } from "buffer";

import { useLogin } from "../../context/LoginContext";
import { useDataBase } from "../../context/DataBaseContext";
import DataList from "../common/DataList";
import Switch from "../common/Switch";
import Input from "../common/Input";
import { IconSave, IconTrash } from "../icons/Icons";
import ButtonPrimaryForm from "../common/ButtonPrimaryForm";

const LettersForm = ({ idData, onClose }) => {
  const [expedientes, setExpedientes] = useState([]);
  const [selectedExp, setSelectedExp] = useState("");
  const [secretarios, setSecretarios] = useState([]);
  const [personas, setPersonas] = useState([]);
  const [selectedRemitente, setSelectedRemitente] = useState("");
  const [selectedDestinatario, setSelectedDestinatario] = useState("");
  const [correlativo, setCorrelativo] = useState(0);
  const [urlFileLocal, setUrlFileLocal] = useState(null);
  const [file, setFile] = useState(null);
  const [formData, setFormData] = useState({
    no_process: false,
    created_at: new Date().toISOString().split("T")[0],
    sending_date: new Date().toISOString().split("T")[0],
    notification_date: new Date().toISOString().split("T")[0],
  });

  const { user } = useLogin();
  const { getCartas } = useDataBase();

  useEffect(() => {
    getExpedientes();
    getSecretarios();
    getPersonas();
    getCorrelativo();
  }, []);

  useEffect(() => {
    formData.no_process &&
      setFormData(() => ({
        ...formData,
        process_id: null,
      }));
  }, [formData.no_process]);

  const getExpedientes = async () => {
    const { error, data } = await supabase.from("process").select(`
            id,
            num_process,
            anio_process,
            class_process(name)
            }
       `);
    if (error) throw error.message;
    const expedientesData = data.map((item) => {
      return {
        value: item.id,
        label:
          item.num_process +
          "-" +
          item.anio_process +
          "-" +
          item.class_process.name,
      };
    });
    setExpedientes(expedientesData);
  };

  const getSecretarios = async () => {
    const { error, data } = await supabase.from("secretaries").select(`
           id,
           users(first_name, last_name)
           }
      `);
    if (error) throw error.message;
    const dataResponse = data.map((item) => {
      return {
        value: item.id,
        label: item.users.first_name + " " + item.users.last_name,
      };
    });
    setSecretarios(dataResponse);
  };

  const getPersonas = async () => {
    const { error, data } = await supabase.from("persons").select(`
           id,
           name
      `);
    if (error) throw error.message;
    const dataResponse = data.map((item) => {
      return {
        value: item.id,
        label: item.name,
      };
    });
    setPersonas(dataResponse);
  };

  const getCorrelativo = async () => {
    const { error, data } = await supabase
      .from("letters")
      .select("id, code")
      .order("id", { ascending: true })
      .limit(1);
    if (error) throw error.message;
    // si no hay datos, se inicia el correlativo en 1
    if (data.length === 0) {
      setCorrelativo(1 + "-" + new Date().getFullYear());
      return;
    }

    // si el año es diferente al actual, se reinicia el correlativo
    const year = new Date().getFullYear();
    const yearCorrelativo = data[0].code.split("-")[1];
    // console.log(+year !== +yearCorrelativo)
    if (+year !== +yearCorrelativo) {
      setCorrelativo(1 + "-" + year);
      return;
    }
    // si el año es igual al actual, se suma 1 al correlativo y concateno el año
    const correlativo = data[0].code.split("-")[0];
    setCorrelativo(+correlativo + 1 + "-" + yearCorrelativo);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(() => ({
      ...formData,
      [name]: value,
    }));
  };

  const handleDataListChange = (e, name) => {
    setFormData(() => ({
      ...formData,
      [name]: e.value,
    }));
  };

  const handleInputSwitchChange = (e) => {
    const { name } = e.target;
    setFormData(() => ({
      ...formData,
      [name]: !formData.no_process,
    }));
  };

  const handleFileChange = async (event) => {
    const fileData = event.target.files[0];
    setUrlFileLocal(URL.createObjectURL(fileData));
    const fileExtension = fileData.name.split(".").pop();
    const keyFile = `${uuidv4()}.${fileExtension}`;
    setFormData({
      ...formData,
      file: keyFile,
    });
    setFile({
      fileData: fileData,
      keyFile: keyFile,
    });
  };

  const uplodFileStorage = async (file) => {
    const { fileData, keyFile } = file;
    const bytes = await fileData.arrayBuffer();
    const buffer = Buffer.from(bytes);
    //  const fileExtension = fileData.name.split(".").pop();
    //  console.log(fileData);
    const bucketParams = {
      Bucket: "ccia-arbitraje",
      Key: `${keyFile}`,
      Body: buffer,
      ACL: "public-read",
    };

    const res = await s3Client.send(new PutObjectCommand(bucketParams));
    return res;
  };

  const existeCorrelativo = async () => {
    // antes de guardar verificar si ya existe el correlativo y actualizar el estado con el correlativo que sigue
    const { error, data } = await supabase
      .from("letters")
      .select("id, code")
      .eq("code", correlativo);
    if (error) throw error.message;
    if (data.length > 0) {
      alert("El correlativo ya existe");
      const numCorrelativo = data[0].code.split("-")[0];
      setCorrelativo(+numCorrelativo + 1 + "-" + new Date().getFullYear());
      return true;
    }
    return false;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    file && (await uplodFileStorage(file));
    //  console.log(formData);
    const existe = await existeCorrelativo();
    if (existe) return;
    // guardar en la base de datos
    const { error } = await supabase.from("letters").insert([
      {
        code: correlativo,
        process_id: formData.process_id,
        remitter_id: formData.remitter_id,
        receiver_id: formData.receiver_id,
        detail: formData.detail,
        created_at: formData.created_at,
        sending_date: formData.sending_date,
        notification_date: formData.notification_date,
        reception_date: formData.reception_date,
        file: formData.file,
        users_id: user.id,
      },
    ]);
    if (error) throw error.message;
    alert("Registro guardado con éxito");
    setFormData({
      no_process: false,
      created_at: new Date().toISOString().split("T")[0],
      sending_date: new Date().toISOString().split("T")[0],
      notification_date: new Date().toISOString().split("T")[0],
    });
    setSelectedExp("");
    setSelectedRemitente("");
    setSelectedDestinatario("");
    setUrlFileLocal(null);
    setFile(null);
    onClose();
    getCartas();
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <div className="grid grid-cols-2 gap-4 mt-4 items-end">
          <div className="flex flex-col gap-1 col-span-2">
            <label className="block text-4xl font-medium text-gray-700 pb-5">
              {correlativo}
            </label>
            <Switch
              title={"Sin expediente"}
              name={"no_process"}
              checked={formData.no_process}
              onChange={handleInputSwitchChange}
            />
          </div>
          <div className="flex flex-col gap-1">
            {formData.no_process === false && (
              <DataList
                textLabel={"Expediente"}
                name={"process_id"}
                className="w-3/4"
                value={selectedExp}
                dataOptions={expedientes}
                onChange={(e) => {
                  handleDataListChange(e, "process_id");
                  const filterData = expedientes.filter(
                    (item) => item.value === e.value
                  );
                  setSelectedExp(filterData[0]);
                }}
              />
            )}
            <DataList
              textLabel={"Remitente"}
              name={"remitter_id"}
              className="w-3/4"
              value={selectedRemitente}
              dataOptions={secretarios}
              onChange={(e) => {
                handleDataListChange(e, "remitter_id");
                const filterData = secretarios.filter(
                  (item) => item.value === e.value
                );
                setSelectedRemitente(filterData[0]);
              }}
            />
            <DataList
              textLabel={"Destinatario"}
              name={"receiver_id"}
              className="w-3/4"
              value={selectedDestinatario}
              dataOptions={personas}
              onChange={(e) => {
                handleDataListChange(e, "receiver_id");
                const filterData = personas.filter(
                  (item) => item.value === e.value
                );
                setSelectedDestinatario(filterData[0]);
              }}
            />
            <Input
              textLabel={"Detalle"}
              typeInput={"text"}
              name={"detail"}
              className="w-3/4"
              value={formData.detail || ""}
              onChange={handleInputChange}
            />
          </div>
          <div className="flex flex-col gap-1">
            <Input
              textLabel={"Fecha elaboración"}
              typeInput={"date"}
              name={"created_at"}
              className="w-3/4"
              value={formData.created_at || ""}
              onChange={handleInputChange}
            />
            <Input
              textLabel={"Fecha envío"}
              typeInput={"date"}
              name={"sending_date"}
              className="w-3/4"
              value={formData.sending_date || ""}
              onChange={handleInputChange}
            />
            <Input
              textLabel={"Fecha notificación"}
              typeInput={"date"}
              name={"notification_date"}
              className="w-3/4"
              value={formData.notification_date || ""}
              onChange={handleInputChange}
            />
            <Input
              textLabel={"Fecha recepción"}
              typeInput={"date"}
              name={"reception_date"}
              className="w-3/4"
              value={formData.reception_date || ""}
              onChange={handleInputChange}
            />
          </div>
          <div className="col-span-2">
            {urlFileLocal ? (
              <div className="flex items-center justify-between gap-2 w-full border border-gray-300 focus:border-gray-400 rounded-lg pl-4 bg-zinc-100">
                <a
                  href={urlFileLocal}
                  target="_blank"
                  rel="noreferrer"
                  className="text-sm font-light hover:text-primary/90 transition-colors duration-300"
                >
                  Ver archivo
                </a>
                <button
                  type="button"
                  className="border border-danger bg-danger p-2 rounded-sm hover:bg-danger/80 text-white transition-colors duration-300"
                  onClick={() => {
                    setUrlFileLocal(null);
                    setFile(null);
                    setFormData({
                      ...formData,
                      file: null,
                    });
                  }}
                >
                  <IconTrash className="w-4 h-4" />
                </button>
              </div>
            ) : (
              <Input
                textLabel={"Archivo:"}
                typeInput={"file"}
                name={"file"}
                className="w-3/4"
                onChange={(e) => handleFileChange(e, "file")}
              />
            )}
          </div>
        </div>
        <div className="flex justify-between items-center gap-2 mt-6">
          <div className="flex flex-col gap-2">
            <span className="text-red-500 text-xs italic">
              * Campos obligatorios
            </span>
          </div>
          <div className="flex gap-2 items-center">
            <ButtonPrimaryForm text={"Guardar"} typeBtn={"submit"}>
              <IconSave className="w-4" />
            </ButtonPrimaryForm>
          </div>
        </div>
      </form>
    </>
  );
};

export default LettersForm;
